var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 503,
    viewBox: "0 0 500 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 184.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 249.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 316,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 28,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 88,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 228,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 65,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 354,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 175,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 400,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 405,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 498,
    r: 4.5,
    fill: "#774FFC",
    stroke: "#774FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingRight);
export default __webpack_public_path__ + "static/media/ring_right.4842c0726330e4699181e0131f6da269.svg";
export { ForwardRef as ReactComponent };